import React from 'react';
import {
  Box,
  Typography,
  Container,
  Card,
  CardContent,
  Stepper,
  Step,
  StepLabel,
} from '@mui/material';
import { styled } from '@mui/material/styles';

const PageContainer = styled(Box)(({ theme }) => ({
  minHeight: '100vh',
  backgroundColor: '#0B0813',
  padding: '40px 20px',
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
  fontSize: '24px',
  fontWeight: 'bold',
  color: '#00F0FF',
  fontFamily: '"Press Start 2P", cursive',
  marginBottom: '30px',
  textTransform: 'uppercase',
  letterSpacing: '2px',
  textShadow: '0 0 10px rgba(0, 240, 255, 0.5)',
}));

const ContentCard = styled(Card)(({ theme }) => ({
  backgroundColor: 'rgba(11, 8, 19, 0.8)',
  border: '1px solid #00F0FF',
  borderRadius: '5px',
  boxShadow: '0 0 15px rgba(0, 240, 255, 0.1)',
  marginBottom: '20px',
}));

const StepTitle = styled(Typography)(({ theme }) => ({
  color: '#39FF14',
  fontFamily: '"JetBrains Mono", monospace',
  fontSize: '16px',
  fontWeight: 'bold',
  marginBottom: '10px',
}));

const StepContent = styled(Typography)(({ theme }) => ({
  color: '#FFFFFF',
  fontFamily: '"JetBrains Mono", monospace',
  fontSize: '14px',
  lineHeight: '1.8',
  marginBottom: '15px',
}));

const HowToHideMessage: React.FC = () => {
  const steps = [
    {
      title: 'Step 1: Enter Secret Data',
      content: 'Type or paste your secret message into the text field on the Encode tab. This can be any text you want to hide inside the image.'
    },
    {
      title: 'Step 2: Encrypt Data',
      content: 'Enter a password to encrypt your message using AES-256-GCM encryption. This ensures that even if someone finds the hidden data, they cannot read it without the password.'
    },
    {
      title: 'Step 3: Upload Image',
      content: 'Select an image file (PNG, BMP, or JPEG) that will contain your hidden message. Larger images can hold more data.'
    },
    {
      title: 'Step 4: Embed into Image',
      content: 'Choose the encoding depth (1, 2, or 4 bits) and click the Encode button. The system will embed your encrypted message into the image pixels.'
    },
    {
      title: 'Step 5: Download Protected Image',
      content: 'Download the processed image. It will look identical to the original but now contains your hidden, encrypted message.'
    }
  ];

  return (
    <PageContainer>
      <Container maxWidth="lg">
        <SectionTitle>How to Hide a Message in an Image</SectionTitle>
        
        <ContentCard>
          <CardContent>
            <Stepper orientation="vertical">
              {steps.map((step, index) => (
                <Step key={index} active>
                  <StepLabel>
                    <StepTitle>{step.title}</StepTitle>
                  </StepLabel>
                  <StepContent>{step.content}</StepContent>
                </Step>
              ))}
            </Stepper>
          </CardContent>
        </ContentCard>

        <ContentCard>
          <CardContent>
            <StepTitle>Additional Tips</StepTitle>
            <StepContent>
              • Use higher bit depths (2 or 4 bits) for larger messages<br />
              • Choose complex images with lots of detail for better hiding<br />
              • Keep your password secure - you need it to decode the message<br />
              • Test with small messages first to ensure quality
            </StepContent>
          </CardContent>
        </ContentCard>
      </Container>
    </PageContainer>
  );
};

export default HowToHideMessage;
